module.exports = __webpack_public_path__ + "static/media/KI.74e2f7d4.svg";